import t from '../helpers/translate';
import { responsiveDeeplinkUrl } from '../deeplinkUtils';
import ExternalLink from './ExternalLink';
import ResponsiveLink from './ResponsiveLink';
import Svg from './Svg';
import '../styles/footer.css';

const Footer = () => (
  <div className="footer">
    <div className="footer-powered">
      <p>{t('Powered by')}</p>
      <ExternalLink ariaLabel="Fishbrain" href={responsiveDeeplinkUrl('footer')}>
        <Svg viewBox="0 0 138 26" className="footer-logo" icon="logo" />
      </ExternalLink>
      <ResponsiveLink campaign="footer_get_app" className="footer-get-app">
        {t('Get the app')}
      </ResponsiveLink>
    </div>
  </div>
);

export default Footer;
